import { StoryblokComponent } from '@storyblok/react'
import React from 'react'

import {
  Headline,
  HeadlineImportances,
} from '@components/atoms/Headline/Headline'
import StoryblokRichText from '@components/storyblok/atoms/StoryblokRichText'

import { PropsWithClassName } from '@helper/PropsWithClassName'
import { editable } from '@helper/storyblokEditable'

import { Root } from './StoryblokGridCard.styles'
import { GridCard } from '@definitions/types/storyblokTypes'

interface Props extends PropsWithClassName {
  blok: GridCard
}

const StoryblokGridCard = (props: Props) => {
  const { blok } = props

  return (
    <Root
      {...editable(blok)}
      className="grid-card"
      dataTestId="storyblok-grid-card-root"
      background={blok.background_color?.toString()}
    >
      {blok.label && (
        <Headline importance={HeadlineImportances.h2}>
          {blok.label.toString()}
        </Headline>
      )}
      {blok.text && (
        <StoryblokRichText key={'StoryblokGridCard-text'} content={blok.text} />
      )}
      {blok.button &&
        blok.button.map((button: any, index: number) => {
          return <StoryblokComponent key={button.text + index} blok={button} />
        })}
    </Root>
  )
}

export { StoryblokGridCard }
